const icon = {
    checkbox: require("@/assets/icons/checkbox_icon.svg"),
    radio: require("@/assets/icons/radio_icon.svg"),
    text: require("@/assets/icons/text_icon.svg"),
    point: require("@/assets/icons/point_icon.svg"),
    rating: require("@/assets/icons/rating_star_icon.svg"),
    bold: require("@/assets/icons/bold.svg"),
    italic: require("@/assets/icons/italic.svg"),
    strikethrough: require("@/assets/icons/strikethrough.svg"),
    underline: require("@/assets/icons/underline.svg"),
    link: require("@/assets/icons/link.svg"),
    image: require("@/assets/icons/image.svg"),
    list_bulleted: require("@/assets/icons/list_bulleted.svg"),
    justify_left: require("@/assets/icons/justify_left.svg"),
    justify_center: require("@/assets/icons/justify_center.svg"),
    justify_right: require("@/assets/icons/justify_right.svg"),
    justify: require("@/assets/icons/justify.svg"),
    text_a: require("@/assets/icons/text.svg"),
    list_number: require("@/assets/icons/list_number.svg"),
    break: require("@/assets/icons/break.svg"),
    line: require("@/assets/icons/line.svg"),
    pen_line: require("@/assets/icons/pen_line.svg"),
    subscript: require("@/assets/icons/subscript.svg"),
    superscript: require("@/assets/icons/superscript.svg")
}

export default icon;